// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';
export const WedgeDownSvgIcon = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg width="1em" height="1em" viewBox="0 0 100 100" {...props}>
    <path fill="#000" d="M50 65L20 36h60z" fillRule="evenodd" />
  </svg>
);
